import { CustomerSetBuilderService } from './../../../../services/customer/customer-set-builder.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/components/common/api';
import { LoyaltyParamsService } from './../../../../services/loyalty/params.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-customer-set-results',
  templateUrl: './customer-set-results.component.html',
  styleUrls: ['./customer-set-results.component.css']
})
export class CustomerSetResultsComponent implements OnInit {
  exportThreshold: number;
  @Input() results = 0;
  @Output() onCloseDialog: EventEmitter<any> = new EventEmitter();
  @Output() onExportResults: EventEmitter<any> = new EventEmitter();

  constructor(
    private paramsService: LoyaltyParamsService,
    private confirmationService: ConfirmationService,
    private translateService: TranslateService,
    private customerSetBuilderService: CustomerSetBuilderService
  ) { }

  ngOnInit() {
    this.paramsService.getParamByKey('CLUSTER_EXPORT_ALERT_TRESHOLD').subscribe(res => this.exportThreshold = +res.param_code);
  }

  exportResults() {
    if (this.results > this.exportThreshold) {
      this.confirmationService.confirm({
        header: this.translateService.instant('customerSetBuilder.warning'),
        message: this.translateService.instant('customerSetBuilder.clusterExportThresholdAlertMsg'),
        accept: () => this.onExportResults.emit(),
        acceptLabel: 'Ok'
      });
    } else if (this.results > 0) {
      this.onExportResults.emit();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-set-builder/customer-set-results/customer-set-results.component.ts